import exportService from "../../services/ClassenService/modules/exportService";

const state = {};

const mutations = {};

const getters = {};

const actions = {
  getImageZip: ({commit}, requestData) => new Promise((resolve, reject) => {
    exportService.getImageZip(requestData)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => reject(error));
  })
};

export default {
  state, mutations, getters, actions,
};
